module.exports = __webpack_public_path__ + "static/media/Maf_04Junio.d8e85194.jpg";